import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url: 'save_error_logger',
    data: info,
    method: 'post'
  })
}

export const uploadImg = formData => {
  return axios.request({
    url: 'image/upload',
    data: formData
  })
}

export const getOrgData = () => {
  return axios.request({
    url: 'get_org_data',
    method: 'get'
  })
}

export const getTreeSelectData = () => {
  return axios.request({
    url: 'get_tree_select_data',
    method: 'get'
  })
}

// --------------

export const getArticleList = (page, size) => {
  return axios.request({
    url: `admin/article/list_title?page=${page}&size=${size}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getArticleDetail = (id) => {
  return axios.request({
    url: `admin/article?id=${id}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const uploadImage = file => {
  let param = new FormData()
  param.append('file', file)
  param.append('optimize', true)
  param.append('scale_width', 1080)
  return axios.request({
    url: 'admin/upload/image',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: param
  })
}

export const syncFileToCos = (file_id, cos_type) => {
  return axios.request({
    url: 'admin/file/sync_cos',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'put',
    data: {
      file_id,
      cos_type
    }
  })
}

export const createArticle = (title, uri, tags, content, type, isDraft) => {
  return axios.request({
    url: 'admin/article',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      title,
      uri,
      'keywords': tags,
      content,
      type,
      'draft': isDraft
    }
  })
}

export const publishArticle = (ID, publish) => {
  return axios.request({
    url: 'admin/article/publish',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'put',
    data: {
      id: ID,
      publish
    }
  })
}

export const saveArticle = (ID, title, uri, tags, content, type) => {
  return axios.request({
    url: 'admin/article',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'put',
    data: {
      id: ID,
      title,
      uri,
      'keywords': tags,
      content,
      type
    }
  })
}

export const deleteArticle = (ID) => {
  return axios.request({
    url: `admin/article?id=${ID}`,
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'delete'
  })
}

export const deleteFile = (ID) => {
  return axios.request({
    url: `admin/file/delete?file_id=${ID}`,
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'delete'
  })
}

export const listAgents = () => {
  return axios.request({
    url: 'agent/list',
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'get'
  })
}

export const removeAgent = (ID) => {
  return axios.request({
    url: `agent/remove?id=${ID}`,
    headers: {
      'X-Token': getToken(),
      'Content-Type': 'application/json'
    },
    method: 'delete'
  })
}

export const getFileList = (page, size) => {
  return axios.request({
    url: `admin/file/list?page=${page}&size=${size}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getMediaFileList = (page, size) => {
  return axios.request({
    url: `admin/album/list?page=${page}&size=${size}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getMediaFileDetail = (id) => {
  return axios.request({
    url: `admin/album/media/detail?id=${id}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getArticleMD5 = (id) => {
  return axios.request({
    url: `admin/article/current_md5?id=${id}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}

export const getLoginHistoryList = (page, size) => {
  console.log('request')
  return axios.request({
    url: `admin/login_history?page=${page}&size=${size}`,
    headers: {
      'X-Token': getToken()
    },
    method: 'get'
  })
}
